import { createCustomCSSPrefixClassName, EmbedRoot } from '@elfsight/widget-ui';
import { useSettings } from '@wu/widget-core';
import { meta } from '../meta';
import { Content } from './content';
import { Layout } from './layout/layout';

export function Main() {
  const { font, width, textColor, widgetId = '' } = useSettings();

  const customCSSPrefixClassName = createCustomCSSPrefixClassName(
    meta.appAlias,
    widgetId
  );

  return (
    <EmbedRoot
      customCSSClassName={customCSSPrefixClassName}
      font={font}
      width={width}
      textColor={textColor}
    >
      <Layout>
        <Content />
      </Layout>
    </EmbedRoot>
  );
}
